import { initialState } from './selectors'
import {
  GET_RECEIPT_PAGE_NUMBER,
  SET_RECEIPT_PAGE_NUMBER,
  SET_RECEIPT_LIMIT_PAGE,
  SET_RECEIPT_FILTER_DATA,
  SET_RECEIPT_TICKET_FILTER_DATA,
  SET_RETAILER_NAME,
  SET_RETAILER_COUNTRY,
  SET_RETAILER_PAGE_NUMBER,
  SET_RETAILER_LIMIT_PAGE,
  SET_RECEIPT_CASE_RESOLVED,
  SET_RECEIPT_CASE_REJECTED,
  SET_RECEIPT_CASE_REJECTED_SUCCESS,
  SET_RECEIPT_CASE_RESOLVED_SUCCESS,
  SET_RECEIPT_CASE_RESOLVED_FAIL,
  SET_RECEIPT_CASE_REJECTED_FAIL,
  GET_RECEIPT_LIST,
  GET_RECEIPT_LIST_SUCCESS,
  GET_RECEIPT_LIST_FAIL,
  SET_RECEIPT_MAPPING,
  SET_RECEIPT_MAPPING_SUCCESS,
  SET_RECEIPT_MAPPING_FAIL,
  SET_RECEIPT_MAPPING_REJECTED,
  SET_RECEIPT_MAPPING_REJECTED_SUCCESS,
  SET_RECEIPT_MAPPING_REJECTED_FAIL,
  SET_RECEIPT_MAPPING_TEMPLATE,
  SET_RECEIPT_MAPPING_TEMPLATE_SUCCESS,
  SET_RECEIPT_MAPPING_TEMPLATE_FAIL
} from './actions'

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_RECEIPT_PAGE_NUMBER:
      return {
        ...state,
        receiptPageNumber: state.receiptPageNumber
      }
    case SET_RECEIPT_PAGE_NUMBER:
      return {
        ...state,
        receiptPageNumber: payload
      }
    case SET_RECEIPT_LIMIT_PAGE:
      return {
        ...state,
        receiptLimitPage: payload
      }
    case SET_RECEIPT_FILTER_DATA:
      return {
        ...state,
        filterData: { ...payload }
      }
    case SET_RECEIPT_TICKET_FILTER_DATA:
      return {
        ...state,
        ticketFilterData: { ...payload }
      }
    case SET_RETAILER_NAME:
      return {
        ...state,
        retailerName: payload
      }
    case SET_RETAILER_COUNTRY:
      return {
        ...state,
        retailerCountry: payload
      }
    case SET_RETAILER_PAGE_NUMBER:
      return {
        ...state,
        retailerPageNumber: payload
      }
    case SET_RETAILER_LIMIT_PAGE:
      return {
        ...state,
        retailerLimitPage: payload
      }
    case GET_RECEIPT_LIST:
      return {
        ...state,
        isLoading: true
      }
    case GET_RECEIPT_LIST_SUCCESS:
      return {
        ...state,
        ...payload,
        isLoading: false
      }
    case GET_RECEIPT_LIST_FAIL:
      return {
        ...state,
        isLoading: false,
        receipts: []
      }
    case SET_RECEIPT_CASE_RESOLVED:
    case SET_RECEIPT_CASE_REJECTED:
    case SET_RECEIPT_CASE_REJECTED_SUCCESS:
    case SET_RECEIPT_CASE_RESOLVED_SUCCESS:
    case SET_RECEIPT_CASE_RESOLVED_FAIL:
    case SET_RECEIPT_CASE_REJECTED_FAIL:
    case SET_RECEIPT_MAPPING:
    case SET_RECEIPT_MAPPING_SUCCESS:
    case SET_RECEIPT_MAPPING_FAIL:
    case SET_RECEIPT_MAPPING_REJECTED:
    case SET_RECEIPT_MAPPING_REJECTED_SUCCESS:
    case SET_RECEIPT_MAPPING_REJECTED_FAIL:
    case SET_RECEIPT_MAPPING_TEMPLATE:
    case SET_RECEIPT_MAPPING_TEMPLATE_SUCCESS:
    case SET_RECEIPT_MAPPING_TEMPLATE_FAIL:
      return {
        ...state
      }
    default:
      return state
  }
}
